import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { AES, enc, PBKDF2 } from 'crypto-js';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environment/environment';
import { env } from 'process';
import { yohainous } from '../../core-node';

@Injectable({ providedIn: 'root' })
export class secureStorage {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
  ) {}
  private vectorAxis = yohainous();

  setItem(key: any, value: any) {
    if (isPlatformBrowser(this.platformId)) {
      let valuenew = AES.encrypt(value, this.vectorAxis.nebulaFlux);
      localStorage.setItem(key, valuenew.toString());
      return null;
    } else {
      return null;
    }
  }

  getItem(key: any) {
    if (isPlatformBrowser(this.platformId)) {
      let valuenew = localStorage.getItem(key);
      if (valuenew) {
        try {
          let data: any = AES.decrypt(valuenew, this.vectorAxis.nebulaFlux);
          data = data.toString(enc.Utf8);

          // If decryption resulted in empty string, the data was corrupted
          if (!data || data.trim() === '') {
            console.warn(
              `Failed to decrypt localStorage item: ${key}. Removing corrupted data.`,
            );
            localStorage.removeItem(key);
            return null;
          }

          return data;
        } catch (error) {
          console.error(`Error decrypting localStorage item: ${key}`, error);
          // Remove corrupted data from localStorage
          localStorage.removeItem(key);
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  clear() {
    if (isPlatformBrowser(this.platformId)) {
      var keys = Object.keys(localStorage),
        i = keys.length;

      while (i--) {
        if (keys[i].startsWith('WZRK')) {
        } else {
          localStorage.removeItem(keys[i]);
        }
      }
      this.router.navigate(['/home']);
    }
  }

  encryptData(data: any) {
    var quantum = this.vectorAxis.quantumSeed; //environment.varss;
    var hyper = this.vectorAxis.hyperVector; //environment.varsalt;
    var iterations = 128;
    var bytes = PBKDF2(quantum, hyper, { keySize: 48, iterations: iterations });
    var iv = enc.Hex.parse(bytes.toString().slice(0, 32));
    var key = enc.Hex.parse(bytes.toString().slice(32, 96));
    var cipherpassword = AES.encrypt(data, key, { iv: iv }).toString();
    return cipherpassword;
  }
  decryptData(data: any) {
    try {
      var quantum = this.vectorAxis.quantumSeed; //environment.varss;
      var hyper = this.vectorAxis.hyperVector; //environment.varsalt;
      var iterations = 128;
      var bytes = PBKDF2(quantum, hyper, {
        keySize: 48,
        iterations: iterations,
      });
      var iv = enc.Hex.parse(bytes.toString().slice(0, 32));
      var key = enc.Hex.parse(bytes.toString().slice(32, 96));
      var cipherpassword: any = AES.decrypt(data, key, { iv: iv });
      cipherpassword = cipherpassword.toString(enc.Utf8);

      if (!cipherpassword || cipherpassword.trim() === '') {
        console.warn('Failed to decrypt data. Result is empty.');
        return null;
      }

      return cipherpassword;
    } catch (error) {
      console.error('Error decrypting data:', error);
      return null;
    }
  }

  allStorage() {
    if (isPlatformBrowser(this.platformId)) {
      var keys = Object.keys(localStorage),
        i = keys.length;

      while (i--) {
        if (keys[i].startsWith('WZRK')) {
        } else {
          localStorage.removeItem(keys[i]);
        }
      }
    }
  }
  removeitems(key: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
      return null;
    } else {
      return null;
    }
  }
}
